import { FlowType } from "@redotech/redo-model/return-flow";
import { Step, StepId } from "@redotech/redo-return-ui/flows/step";

export const RETURN_REASON_TITLE = "Return reason";
export const CLAIM_REASON_TITLE = "Claim reason";
export const WARRANTY_REASON_TITLE = "Warranty reason";

export function reasonTitleForFlowType(flowType: FlowType): string {
  switch (flowType) {
    case FlowType.CLAIM:
    case FlowType.FINALIZE_CLAIM:
      return CLAIM_REASON_TITLE;
    case FlowType.WARRANTY:
    case FlowType.WARRANTY_REGISTRATION:
      return WARRANTY_REASON_TITLE;
    default:
      return RETURN_REASON_TITLE;
  }
}

export function getAllPathsToStep(
  startStepId: StepId,
  targetStepId: StepId,
  allSteps: Map<StepId, Step>,
): StepId[][] {
  const queue: { path: StepId[]; current: StepId }[] = [
    { path: [startStepId], current: startStepId },
  ];
  const result: StepId[][] = [];
  while (queue.length > 0) {
    const { path, current } = queue.shift()!;
    if (current === targetStepId) {
      result.push(path);
      continue;
    }
    const step = allSteps.get(current);
    if (!step) continue;
    // Get downstream step ids
    const downstreams = step
      .downstream()
      .map((ds) => ds.id)
      .filter(Boolean) as StepId[];
    for (const nextId of downstreams) {
      if (path.includes(nextId)) continue; // avoid cycles
      queue.push({ path: [...path, nextId], current: nextId });
    }
  }
  return result;
}

export function isBonusAdjustment(adjustmentString: string): boolean {
  return parseFloat(adjustmentString) >= 0;
}
